<!-- Budget Details -->
@if (budget) {
    <div class="fxlayout-row-stretch">
        <!-- Description card -->
        <mat-card class="children-equal-3">
            <mat-card-title>
                <div class="budget-header-top-row">
                    <div class="budget-header-left">
                        <div class="budget-nav-pill">
                            <button mat-icon-button
                                    type="button"
                                    [disabled]="!hasPreviousBudget"
                                    (click)="goToPreviousBudget()"
                                    [matTooltip]="hasPreviousBudget ? 'Previous budget in filtered list' : 'First budget in list'"
                                    class="budget-nav-btn">
                                <mat-icon>chevron_left</mat-icon>
                            </button>
                            @if (budgetNavPositionText) {
                                <span class="budget-nav-counter">{{ budgetNavPositionText }}</span>
                            }
                            <button mat-icon-button
                                    type="button"
                                    [disabled]="!hasNextBudget"
                                    (click)="goToNextBudget()"
                                    [matTooltip]="hasNextBudget ? 'Next budget in filtered list' : 'Last budget in list'"
                                    class="budget-nav-btn">
                                <mat-icon>chevron_right</mat-icon>
                            </button>
                        </div>

                        <div class="budget-id-group">
                            @if (budget.project?.projectNr) {
                                <span class="project-number">{{ budget.project.projectNr }}</span>
                                <span class="slash-separator">/</span>
                            }
                            <span class="budget-number">{{ budget.budgetNr }}</span>
                            @if (budget.version) {
                                <span class="budget-version">({{ budget.version }})</span>
                            }
                        </div>
                    </div>

                    @if (budgetFolderLink) {
                        <a [href]="budgetFolderLink"
                           class="drive-folder-btn"
                           matTooltip="Open Google Drive Folder"
                           target="_blank">
                            <mat-icon class="folder-icon">folder</mat-icon>
                            <span i18n>Drive</span>
                            <mat-icon class="external-icon">open_in_new</mat-icon>
                        </a>
                    }
                </div>

                @if (budget.budgetName || budget.description || budget.company?.companyName || (budget.project && budget.project.internal) || budget.status === 'archived') {
                    <div class="budget-header-description-row">
                        @if (budget.status === 'archived') {
                            <span class="app-chip archived-chip">ARCHIVED</span>
                        }
                        @if (budget.project && budget.project.internal && !budget.project.promo) {
                            <span class="app-chip internal-chip">Internal</span>
                        }
                        @if (budget.project && budget.project.promo) {
                            <span class="app-chip promo-chip">Promo</span>
                        }
                        @if (budget.budgetName) {
                            <span class="opp-name">{{ budget.budgetName }}</span>
                        }
                        @if (budget.description && budget.description !== budget.budgetName) {
                            <span class="opp_detail">{{ budget.description }}</span>
                        }
                        @if (budget.company?.companyName) {
                            <span class="opp-company">[{{ budget.company.companyName }}]</span>
                        }
                    </div>
                }
            </mat-card-title>
            <mat-card-content class="budget-meta-content">
                <div class="budget-meta-grid">
                    <!-- Column 1: Dates & Timeline -->
                    <div class="budget-meta-column">
                        @if (budget.creation) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Created on</span>
                                <span class="meta-value">{{ budget.creation | timestamp | date }}</span>
                            </div>
                        }
                        @if (budget.offerDate) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Offer Date</span>
                                <span class="meta-value">{{ budget.offerDate | timestamp | date }}</span>
                            </div>
                        }
                        @if (budget.deliveryThr) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>To be delivered</span>
                                <span class="meta-value highlight-date">{{ budget.deliveryThr | timestamp | date }}</span>
                            </div>
                        }
                        @if (budget.archivedDate) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Closed on</span>
                                <span class="meta-value">{{ budget.archivedDate | timestamp | date }}</span>
                            </div>
                        }
                    </div>

                    <!-- Column 2: People & References -->
                    <div class="budget-meta-column">
                        @if (budget.author) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Author</span>
                                <span class="meta-value">{{ budget.author?.displayName }}</span>
                            </div>
                        }
                        @if (budget.assignee && budget.assignee.on) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Assigned to</span>
                                <span class="meta-value">
                  {{ budget.assignee?.displayName }}
                                    <span class="meta-subtext">({{ budget.assignee?.on | timestamp | date }})</span>
                </span>
                            </div>
                        }
                        @if (budget.project?.projectManager) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Project Manager</span>
                                <span class="meta-value">{{ budget.project?.projectManager.displayName }}</span>
                            </div>
                        }
                        @if (permissions.canOpenProject && budget.company?.cosmoId) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Cosmo ID</span>
                                <span class="meta-value cosmo-id">{{ budget.company?.cosmoId }}</span>
                            </div>
                        }
                        @if (budget.ref) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Ref</span>
                                <span class="meta-value">{{ budget.ref }}</span>
                            </div>
                        }
                    </div>

                    <!-- Column 3: Offers, Links & Figures -->
                    <div class="budget-meta-column">
                        @if (this.offerUrl) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Offer</span>
                                <div class="meta-offer-container">
                                    <a [href]="this.offerUrl" target="_blank" class="meta-link"
                                       matTooltip="Open Offer Document">
                                        <mat-icon class="link-icon">description</mat-icon>
                                        <span i18n>Open</span>
                                    </a>
                                    @if (budget.allOffers?.length) {
                                        <button mat-icon-button class="meta-history-btn"
                                                matTooltip="View offers history"
                                                (click)="openOffersHistoryDialog(budget)">
                                            <mat-icon>history</mat-icon>
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                        @if (exportBudget && exportBudget.offerUrl) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Export Offer</span>
                                <div class="meta-offer-container">
                                    <a [href]="exportBudget.offerUrl" target="_blank" class="meta-link"
                                       matTooltip="Open Export Offer Document">
                                        <mat-icon class="link-icon">description</mat-icon>
                                        <span i18n>Open</span>
                                    </a>
                                    @if (budget.allOffers?.length) {
                                        <button mat-icon-button class="meta-history-btn"
                                                matTooltip="View export offers history"
                                                (click)="openOffersHistoryDialog(exportBudget)">
                                            <mat-icon>history</mat-icon>
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                        @if (budget.opportunityIds?.length > 0) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Opportunity</span>
                                <a [routerLink]="['/opportunities', budget.opportunityIds[0]]" class="meta-link"
                                   matTooltip="Go to Opportunity">
                                    <mat-icon class="link-icon">open_in_new</mat-icon>
                                    <span i18n>View</span>
                                </a>
                            </div>
                        }
                        @if (exportBudget) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Export</span>
                                <a [routerLink]="['/budget', exportBudget.id]" class="meta-link">
                                    <mat-icon class="link-icon">link</mat-icon>
                                    <span>{{ exportBudget.budgetNr }}</span>
                                </a>
                            </div>
                        }
                        @if (budget.export && budget.export.from) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Import</span>
                                <a [routerLink]="['/budget', budget.export.from.id]" class="meta-link">
                                    <mat-icon class="link-icon">link</mat-icon>
                                    <span>{{ budget.export.from.budgetNr }}</span>
                                </a>
                            </div>
                        }
                        @if (budget.budgetCostTotal) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Cost tot.</span>
                                <span class="meta-value">{{ budget.budgetCostTotal | currency:budget.export ? 'USD' : 'EUR' }}</span>
                            </div>
                        }
                        @if (budget.budgetHoursTotal) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Hours tot.</span>
                                <span class="meta-value">{{ budget.budgetHoursTotal | currency:budget.export ? 'USD' : 'EUR' }}</span>
                            </div>
                        }
                        @if (budget.budgetMaterialsTotal) {
                            <div class="meta-item">
                                <span class="meta-label" i18n>Material tot.</span>
                                <span class="meta-value">{{ budget.budgetMaterialsTotal | currency:budget.export ? 'USD' : 'EUR' }}</span>
                            </div>
                        }
                    </div>
                </div>

                @if (this.loading) {
                    <div class="loading-bar-wrapper">
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </div>
                }
                <div class="button-row">
                    @if (['new'].includes(budget.status) && permissions.canDeleteBudget) {
                        <button class="m1" (click)="deleteBudget()"
                                [disabled]="this.loading|| budgetIsEmpty" color="warn" i18n mat-raised-button>
                            Delete
                        </button>
                    }
                    @if (['assigned'].includes(budget.status) && permissions.canOpenProject) {
                        <button class="m1" (click)="mergeBudget()"
                                [disabled]="this.loading" i18n mat-raised-button>
                            Merge
                        </button>
                    }
                    @if (['new'].includes(budget.status) && permissions.canAssignBudget) {
                        <button class="m1" (click)="openAssignDialog()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Assign
                        </button>
                    }
                    @if (!['new', 'archived'].includes(budget.status) && permissions.canAssignBudget) {
                        <button class="m1" (click)="reopenAssignDialog()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Re-Assign
                        </button>
                    }
                    @if (isBudgetInEditableStatus && permissions.canPrepareOffer && !budget.export) {
                        <button class="m1"
                                [disabled]="this.loading || !budget.company?.companyId"
                                [matMenuTriggerFor]="offerMenu" i18n mat-raised-button>
                            Prepare Offer
                        </button>
                    }
                    <mat-menu #offerMenu="matMenu">
                        @for (t of offerTemplates; track t) {
                            <button (click)="chooseCompanyToPrepareOffer(t, false)"
                                    [disabled]="this.loading"
                                    mat-menu-item>
                                {{ t.name }}
                            </button>
                        }
                    </mat-menu>
                    @if (exportBudget && exportBudget.status !== 'closed' && offerExportTemplates) {
                        <button class="m1"
                                [disabled]="this.loading"
                                [matMenuTriggerFor]="offerExportMenu" i18n mat-raised-button>
                            Prepare Offer (USA)
                        </button>
                    }
                    <mat-menu #offerExportMenu="matMenu">
                        @for (t of offerExportTemplates; track t) {
                            <button (click)="chooseCompanyToPrepareOffer(t, true)"
                                    mat-menu-item>
                                {{ t.name }}
                            </button>
                        }
                    </mat-menu>
                    @if (permissions.canCreateReport) {
                        <button class="m1" (click)="getReportFile()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Send me Report file
                        </button>
                    }
                    @if (['assigned'].includes(budget.status) && permissions.canOpenProject) {
                        <button class="m1" (click)="openProject()"
                                [disabled]="this.loading" i18n mat-raised-button>
                            Open Project
                        </button>
                    }
                    @if (budget.status === 'archived' && permissions.canOpenProject) {
                        <button class="m1" (click)="reOpenProject()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Reopen
                        </button>
                    }
                    @if (['new', 'assigned'].includes(budget.status) && permissions.canArchiveBudget) {
                        <button class="m1" (click)="archive()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Archive Budget
                        </button>
                    }
                    @if (budget.status === 'closed' && permissions.canOpenProject) {
                        <button class="m1" (click)="archive()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Archive Project
                        </button>
                    }
                    @if (createExportBudgetBtn) {
                        <button class="m1" (click)="createExportBudget()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Generate Export
                        </button>
                    }
                    @if (removeExportLinkBtn) {
                        <button class="m1" (click)="removeExportLink()"
                                [disabled]="this.loading"
                                i18n mat-raised-button>
                            Remove export link
                        </button>
                    }
                </div>
                <div class="button-row">
                    <mat-form-field style="margin-left:10px;">
                        <mat-select (selectionChange)="filterChange()" [(ngModel)]="tagFilter" multiple
                                    placeholder="Filter">
                            @for (tag of (tags$ | async) ?? []; track tag) {
                                <mat-option [value]="tag">{{ tag }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field style="margin-left:10px;">
                        <mat-select [(ngModel)]="budgetScope" multiple placeholder="Scope"
                                    (selectionChange)="scopeChange()"
                                    [disabled]="!permissions.canChangeScopes">
                            @for (scope of BUDGET_SCOPES; track scope) {
                                <mat-option [value]="scope"
                                            [disabled]="budgetScope.length === 3 && !budgetScope.includes(scope)">{{ scope }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                @if (!budget.status) {
                    <div>
                        <p class="warn-message" i18n>
                            This budget cannot be edited because his status is unknown.
                        </p>
                    </div>
                }
                <!-- buttons for modify open projects/assigned budgets which normally can't be modified -->
                @if (['closed', 'assigned'].includes(budget.status)) {
                    <div>
                        @if (permissions.canGrantProjectAuth || permissions.canAskProjectAuth) {
                            <div>
                                <div class="row-centered">
                                    <b>Modification Permissions</b>
                                    @if (permissions.canAskProjectAuth && !hasModifyAuth()) {
                                        <a (click)="askBudgetModifyAuth()"
                                           [disabled]="this.loading"
                                           mat-button
                                           color="accent"
                                           class="ml-1">
                                            <span i18n>Ask permission</span>
                                        </a>
                                    }
                                </div>
                                <table class="permission-table">
                                    <thead>
                                    <tr>
                                        <th i18n>User</th>
                                        <th i18n>Status & Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        @for (grant of budget.authGrants | keyvalue; track grant) {
                                            <tr>
                                                <td>{{ grant.key }}</td>
                                                <td>
                                                    @switch (grant.value) {
                                                        @case ('waiting') {
                                                            <span i18n class="ml-1">Pending..</span>
                                                            @if (permissions.canGrantProjectAuth) {
                                                                <button
                                                                        (click)="ackBudgetModifyAuth(grant.key, true)"
                                                                        color="primary"
                                                                        [disabled]="this.loading"
                                                                        mat-button>
                                                                    <span i18n>Authorize</span>
                                                                </button>
                                                            }
                                                            @if (permissions.canGrantProjectAuth) {
                                                                <button
                                                                        (click)="ackBudgetModifyAuth(grant.key, false)"
                                                                        color="warn"
                                                                        [disabled]="this.loading"
                                                                        mat-button>
                                                                    <span i18n>Deny</span>
                                                                </button>
                                                            }
                                                        }
                                                        @case (null) {
                                                            <span i18n class="ml-1">None</span>
                                                        }
                                                        @default {
                                                            @if (isTimestamp(grant.value)) {
                                                                <span class="authorized-txt ml-1" i18n
                                                                      matTooltip="{{grant.value | timestamp | date}}">Authorized</span>
                                                            }
                                                            @if (permissions.canGrantProjectAuth) {
                                                                <button
                                                                        (click)="ackBudgetModifyAuth(grant.key, false)"
                                                                        color="warn"
                                                                        [disabled]="this.loading"
                                                                        mat-button>
                                                                    <span i18n>Deny</span>
                                                                </button>
                                                            }
                                                            @if (getModifyAuth() && getModifyAuth() !== 'no' && getModifyAuth() !== 'waiting' && grant.key === currentUserEmail) {
                                                                <a (click)="doneModifications()"
                                                                   color="accent"
                                                                   [disabled]="this.loading"
                                                                   class="ml-1"
                                                                   mat-button>
                                                                    <span i18n>Reset</span>
                                                                </a>
                                                            }
                                                        }
                                                        @case ('no') {
                                                            <span class="not-authorized-txt ml-1" i18n>Denied</span>
                                                        }
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                }
            </mat-card-content>
        </mat-card>
        <!-- Costs card -->
        @if (permissions.canSeeFigures && !budget.export) {
            <mat-card class="children-equal-3 total-summary-card pt-0">
                <div>
                    <h4>Costs:</h4>
                    <table [dataSource]="costsTableData" class="mat-elevation-z0 full-width" mat-table>
                        <ng-container matColumnDef="label">
                            <td *matCellDef="let element" mat-cell>
                                {{ element.label }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="value">
                            <td *matCellDef="let element" mat-cell>
                                {{ element.value | currency:element.currency:'symbol':'1.0-0' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <td *matCellDef="let element" mat-cell>
                                <mat-icon class="info-icon" matTooltip="{{element.description}}">info</mat-icon>
                                <!-- For changing finalOffer on the budget -->
                                @if (permissions.canChangeFinalOffer && budget.status === 'closed' && element.label ===
                                'Final Offer ITA') {
                                    <mat-icon (click)="changeFinalOffer(false)" class="icons" mat-raised-button>
                                        edit
                                    </mat-icon>
                                }
                            </td>
                        </ng-container>
                        <tr *matRowDef="let row; columns: costsTablesColumns;" mat-row></tr>
                    </table>
                </div>
                @if (showExport && exportBudget) {
                    <div>
                        <h4>USA costs:</h4>
                        <table [dataSource]="costsTableDataExport" class="mat-elevation-z0 full-width" mat-table>
                            <ng-container matColumnDef="label">
                                <td *matCellDef="let element" mat-cell>
                                    {{ element.label }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="value">
                                <td *matCellDef="let element" mat-cell>
                                    {{ element.value | currency:element.currency:'symbol':'1.0-0' }}
                                    @if (element.valueCurrency) {
                                        <span>
                    &nbsp;&nbsp;({{ element.valueCurrency | currency:'EUR':'symbol':'1.0-0' }})
                  </span>
                                    }
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <td *matCellDef="let element" mat-cell>
                                    <mat-icon class="info-icon" matTooltip="{{element.description}}">info
                                    </mat-icon>
                                    <!-- For changing finalOffer on the budget -->
                                    @if (permissions.canChangeFinalOffer && exportBudget.status === 'closed' && element.label === 'Final Offer USA') {
                                        <mat-icon (click)="changeFinalOffer(true)"
                                                  class="icons" mat-raised-button>
                                            edit
                                        </mat-icon>
                                    }
                                </td>
                            </ng-container>
                            <tr *matRowDef="let row; columns: costsTablesColumns;" mat-row></tr>
                        </table>
                    </div>
                }
                <!-- payment status  & button -->
                <div class="centered-row">
                    <div class="centered-row">
                        <h4>Payment status:&nbsp;</h4>
                        @if (!budget.paymentStatus) {
                            <span> </span>
                        }
                        @if (budget.paymentStatus) {
                            <span>&nbsp;&nbsp;{{ budget.paymentStatus?.completion }}
                                %&nbsp;&nbsp;</span>
                        }
                        @if (budget.project && !budget.project.internal && budget.paymentStatus && budget.paymentStatus.errors.length > 0 && cosmoEnabled) {
                            <span
                                    class="errorMessage"
                                    i18n>
          {{ budget.paymentStatus.errors }}
        </span>
                        }
                    </div>
                    @if (exportBudget) {
                        <mat-slide-toggle (change)="applyShowExport($event.checked)" [checked]="showExport">
                            Show/hide USA
                        </mat-slide-toggle>
                    }
                </div>
                @if ((thereArePendingJobs$ | async) || (thereArePendingJobsExport$ | async)) {
                    <span
                            matTooltip="This budget has some pending jobs, the numbers you see may not be updated."
                            class="pending-jobs-chip app-chip">
          Pending calculations
        </span>
                }
                @if ((thereArePendingJobs$ | async) || (thereArePendingJobsExport$ | async)) {
                    <span
                            class="pipe-separator"></span>
                }
                <button (click)="refreshCostSummary(bId)" [disabled]="refreshingCostSummary" class="refresh-button"
                        mat-mini-fab>
                    <mat-icon>refresh</mat-icon>
                </button>
            </mat-card>
        }
        <!-- graph card -->
        <mat-card class="children-equal-3 chart-summary-card">
            <app-summary-chart [data]="subBudgetValuesForChart"></app-summary-chart>
        </mat-card>
    </div>
}


<!-- Tabs for resumes and sub-budgets -->
@if (budget) {
    <mat-tab-group #subBudgetsTabs [selectedIndex]="selectedTab">
        @if (permissions.canSeeFigures && budget) {
            <mat-tab label="Summary">
                <ng-template mat-tab-label>
                    <b i18n>Summary</b>
                </ng-template>
                <div class="fxlayout-row">
                    <mat-card style="flex:1 1 12%">
                        @if (budget.version === 'v1') {
                            <app-margin-form-v1
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="budget"
                                    [kind]="importBudget ? 'USA' : 'ITA'">
                            </app-margin-form-v1>
                        }
                        @if (budget.version === 'v2') {
                            <app-margin-form-v2
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="budget"
                                    [kind]="importBudget ? 'USA' : 'ITA'">
                            </app-margin-form-v2>
                        }
                    </mat-card>
                    @if (!budget.export) {
                        <mat-card style="flex:1 1 12%">
                            <app-assemblyCosts-form
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="budget">
                            </app-assemblyCosts-form>
                        </mat-card>
                    }
                    <mat-card class="children-small-3">
                        @if (budget.version === 'v1' && budget.export) {
                            <app-production-costs-form-v1
                                    (changeSelectedTab)="changeTab($event)"
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="budget">
                            </app-production-costs-form-v1>
                        }
                        @if (budget.version === 'v2') {
                            <app-production-costs-form-v2
                                    (changeSelectedTab)="changeTab($event)"
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="budget">
                            </app-production-costs-form-v2>
                        }
                    </mat-card>
                    <mat-card style="flex:3 1 48%">
                        @if (budget.version === 'v1') {
                            <app-splitted-costs-table-v1
                                    [isExportBudget]="!!importBudget"
                                    [summary]="importBudget ? splittedCostsTableDataExport : splittedCostsTableDataIta">
                            </app-splitted-costs-table-v1>
                        }
                        @if (budget.version === 'v2') {
                            <app-splitted-costs-table-v2
                                    [isExportBudget]="!!importBudget"
                                    [summary]="importBudget ? splittedCostsTableDataExport : splittedCostsTableDataIta">
                            </app-splitted-costs-table-v2>
                        }
                    </mat-card>
                </div>
            </mat-tab>
        }
        @if (showExport && exportBudget && permissions.canSeeFigures && budget) {
            <mat-tab label="Summary USA">
                <ng-template mat-tab-label>
                    <b i18n style="color: rgb(237, 49, 154);">Summary USA</b>
                </ng-template>
                <div class="fxlayout-row">
                    <mat-card class="children-small-3">
                        @if (exportBudget.version === 'v1') {
                            <app-margin-form-v1
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="exportBudget"
                                    [kind]="'USA'">
                            </app-margin-form-v1>
                        }
                        @if (exportBudget.version === 'v2') {
                            <app-margin-form-v2
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="exportBudget"
                                    [kind]="'USA'">
                            </app-margin-form-v2>
                        }
                    </mat-card>
                    <mat-card class="children-small-3">
                        <app-assemblyCosts-form (updateCostSummary)="refreshCostSummary($event)"
                                                [budget]="exportBudget">
                        </app-assemblyCosts-form>
                    </mat-card>
                    <mat-card class="children-small-3">
                        @if (exportBudget.version === 'v1') {
                            <app-production-costs-form-v1
                                    (changeSelectedTab)="changeTab($event)"
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="exportBudget">
                            </app-production-costs-form-v1>
                        }
                        @if (exportBudget.version === 'v2') {
                            <app-production-costs-form-v2
                                    (changeSelectedTab)="changeTab($event)"
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budget]="exportBudget">
                            </app-production-costs-form-v2>
                        }
                    </mat-card>
                    <mat-card class="children-usa-4">
                        @if (exportBudget.version === 'v1') {
                            <app-splitted-costs-table-v1
                                    [isExportBudget]="true"
                                    [summary]="splittedCostsTableDataExport"></app-splitted-costs-table-v1>
                        }
                        @if (exportBudget.version === 'v2') {
                            <app-splitted-costs-table-v2
                                    [isExportBudget]="true"
                                    [summary]="splittedCostsTableDataExport"></app-splitted-costs-table-v2>
                        }
                    </mat-card>
                </div>
            </mat-tab>
        }
        <!-- subBudget resume -->
        <mat-tab [label]="'Resume'">
            <ng-template mat-tab-label>
        <span [class]="'custom-inline-icon'">
          Resume&nbsp;
          <mat-icon>timer</mat-icon>
        </span>
            </ng-template>
            <app-sub-budget-resume [budgetId]="this.budget.id"
                                   [budgetTotal]="budget?.costSummary?.total"
                                   [budget]="budget"
                                   [subBudgets]="sbCollNameMap"
                                   [tabSelector]="selectedTab"></app-sub-budget-resume>
        </mat-tab>
        <!-- subbudgets -->
        @for (sb of sbColl$ | async; track sb; let i = $index) {
            @if (checkFilters(sb.tags)) {
                <mat-tab [label]="sb.description">
                    <ng-template mat-tab-label>
            <span [class]="sb.calculate? 'custom-inline-icon' :'custom-inline-icon mat-label-disabled'">
              {{ sb.description }}&nbsp;
                @if (sb.overrideEdit) {
                    <mat-icon>whatshot</mat-icon>
                }
            </span>
                    </ng-template>
                    <app-sub-budget (delete)="deleteSubBudget($event)"
                                    (tagsUpdated)="toggleCalculate($event,sb)"
                                    (update)="updateSubBudgetValues($event, sb.id)"
                                    (updateCostSummary)="refreshCostSummary($event)"
                                    [budgetTotal]="budget?.costSummary?.total"
                                    [budget]="budget"
                                    [subBudgetId]="sb.id"></app-sub-budget>
                </mat-tab>
            }
        }
        <!-- end subbudgets -->
        <!-- export subbudgets -->
        @if (showExport && exportBudget) {
            @for (sb of sbCollExport$ | async; track sb; let i = $index) {
                <span>
          @if (checkFilters(sb.tags)) {
              <mat-tab [label]="sb.description">
              <ng-template mat-tab-label>
                <span [class]="sb.calculate? 'custom-inline-icon' :'custom-inline-icon mat-label-disabled'">
                  <b style="color: rgb(237, 49, 154);">{{ sb.description }}</b>&nbsp;
                    @if (sb.overrideEdit) {
                        <mat-icon>whatshot</mat-icon>
                    }
                </span>
              </ng-template>
              <app-sub-budget (delete)="deleteSubBudget($event)" (tagsUpdated)="toggleCalculate($event,sb)"
                              [budgetTotal]="exportBudget?.costSummary?.total" [budget]="exportBudget"
                              [subBudgetId]="sb.id"></app-sub-budget>
            </mat-tab>
          }
        </span>
            }
        }
        <!-- end export subbudgets -->
        <!-- Add a new subBudget -->
        @if (!budget.export && permissions.canAddSubBudget) {
            <mat-tab
                    label=" Add New..."
                    [disabled]="!areScopesSet">
                <mat-card>
                    <app-sub-budget-form (onSubmit)="addSubBudget($event)"></app-sub-budget-form>
                </mat-card>
            </mat-tab>
        }
        <!-- end Add a new subBudget -->
    </mat-tab-group>
}


@if (!budget) {
    <div class="fxlayout-column">
        <mat-progress-spinner class="fxlayout-center-column"></mat-progress-spinner>
    </div>
}
